import React, { useState } from 'react';
import { ButtonBase, Stack, Typography, Menu, MenuItem } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { RiAddFill } from 'react-icons/ri';
import { FormValues } from '../../types';
import { newFirestoreId } from 'common/utils/dataMigrations';
import { CustomContentImage, CustomContentText } from 'common/modules/customization';
import { useTranslation } from 'services/localization';

export interface Props {
	sectionIndex: number;
}
const AddCustomContentButton = (props: Props) => {
	const { sectionIndex } = props;

	const { t } = useTranslation();
	const { control } = useFormContext<FormValues>();
	const { append } = useFieldArray({
		control,
		name: `onlineLayout.about.customContent.sections.${sectionIndex}.content`,
	});
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const defaultImageContent: CustomContentImage = {
		id: newFirestoreId(),
		src: null,
		type: 'image',
	};

	const defaultTextContent: CustomContentText = {
		id: newFirestoreId(),
		type: 'text',
	};

	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<Stack
			py={2}
			ml={-2}
			mr={-2}
			sx={{ borderTop: (theme) => `1px solid ${theme.palette.border.divider}` }}
		>
			<ButtonBase onClick={(e) => setAnchorEl(e.currentTarget)}>
				<Stack direction="row" spacing={1} alignItems="center">
					<Typography color="primary">
						<RiAddFill size={16} />
					</Typography>
					<Typography
						variant="body2"
						sx={{ textTransform: 'uppercase', fontWeight: 600 }}
						color="primary"
					>
						{t('common:actions.addContent', 'Add content')}
					</Typography>
				</Stack>
			</ButtonBase>
			<Menu
				open={!!anchorEl}
				id="custom-content-menu"
				anchorEl={anchorEl}
				onClose={handleClose}
				PaperProps={{
					sx: {
						width: 350,
					},
				}}
			>
				<MenuItem
					onClick={() => {
						append(defaultImageContent);
						handleClose();
					}}
					value="image"
				>
					{t('common:form.image', 'Image')}
				</MenuItem>
				<MenuItem
					onClick={() => {
						append(defaultTextContent);
						handleClose();
					}}
					value="text"
				>
					{t('common:form.text', 'Text')}
				</MenuItem>
			</Menu>
		</Stack>
	);
};

export default AddCustomContentButton;
